import React from 'react';
import { FaCrown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useProSubscription } from '../contexts/ProSubscriptionContext';
import { UserTypes } from '../constants/UserTypes';
import { getUserType } from '../utils/Utils';
import * as LinkFactory from '../routing/LinkFactory';
import './BliftProBadge.css';

const BliftProBadge: React.FC = () => {
    const { hasProAccess, isLoading } = useProSubscription();
    const navigate = useNavigate();
    const userType = getUserType();

    // Only show badge for RCICs who don't have Pro access
    if (isLoading) {
        // Don't render while loading to avoid flickering
        return null;
    }

    if (userType !== UserTypes.RCIC || hasProAccess) {
        return null;
    }

    const handleClick = () => {
        navigate(LinkFactory.rcic_plans_pricing);
    };

    return (
        <button 
            className="blift-pro-badge"
            onClick={handleClick}
            title="Upgrade to Blift Pro"
            aria-label="Blift Pro - Upgrade now"
        >
            <FaCrown className="blift-pro-badge__icon" />
            <span className="blift-pro-badge__text">Upgrade to Blift Pro</span>
        </button>
    );
};

export default BliftProBadge;
